import { render } from "./Scraping.vue?vue&type=template&id=179ba319"
import script from "./Scraping.vue?vue&type=script&lang=js"
export * from "./Scraping.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__